import styled from 'styled-components';

const StyledControlsContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 80px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 80px;
`;

const StyledRightContainer = styled.div`
	position: absolute;
	top: 80px;
	right: 80px;
	display: flex;
	gap: 40px;
`;

const StyledSellAllButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
`;

export {
	StyledControlsContainer,
	StyledRightContainer,
	StyledSellAllButtonContent,
};
